import { ToastrService } from "ngx-toastr";
import { DomSanitizer } from "@angular/platform-browser";
import { Pipe } from "@angular/core";
import { FormGroup } from "@angular/forms";

export function fileToBase64(file: Blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}

export function checkFormValidity(form: FormGroup): void {
	Object.keys(form.controls).forEach(key => {
		let control = form.get(key);
		if (control instanceof FormGroup) {
			checkFormValidity(control);
		} else {
			control.markAsTouched({
				onlySelf: true
			})
		}
	})
}

export function displayOperation(operations, functionalities) {
	for (let i = 0; i < operations.length; i++) {
		if (!functionalities.find(item => item.nome == operations[i])) {
			return false;
		}
	}
	return true;
}

export function substrBase64(base64) {
  return base64.toString().substring(base64.indexOf(",") + 1) == "data:"
    ? ""
    : base64.toString().substring(base64.indexOf(",") + 1);
}

export function checkResponse(data, toasterService: ToastrService, field?) {
  if (data.esito == 0) {
    if (field) {
      return data[field];
    }
    return data;
  } else {
    toasterService.error(null, data.descrizione, {
      disableTimeOut: false
    });
    return null;
  }
}

export function showSuccessOrErrorToast(data, success, toasterService, languageService) {
	if (data.esito == 0) {
		toasterService.success(null, languageService.getValue(success))
	} else {
		toasterService.error(null, languageService.getErrorValue(data.esito), {
			disableTimeOut: true
		});
	}
}

export var localeStringFomat = { year: "numeric", month: "2-digit", day: "2-digit", hour: "numeric", minute: "2-digit" };
export var localeNoOreStringFomat = { year: "numeric", month: "2-digit", day: "2-digit" };

@Pipe({ name: "safeHtml" })
export class Safe {
  constructor(private sanitizer: DomSanitizer) {}

  transform(style) {
    return this.sanitizer.bypassSecurityTrustHtml(style);
    //return this.sanitizer.bypassSecurityTrustStyle(style);
    // return this.sanitizer.bypassSecurityTrustXxx(style); - see docs
  }
}
